import { render, staticRenderFns } from "./AppEditable.vue?vue&type=template&id=8533b3a4&"
import script from "./AppEditable.vue?vue&type=script&lang=js&"
export * from "./AppEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports